// import Login from '../../views/Pages/Login'
import Login from '../../views/Pages/Login/Login.v2'
// import Login from '../../views/Pages/Login/Login.Kiosk'
import WithFormEvent from '../../components/WithFormEvent'
import { ajaxPost, loginInfo, history, connection } from '../../global';
import queryString from 'query-string';

// export const ValidSearch = (TargetSearch) => {
//   TargetSearch = TargetSearch.substring(1);
//   var dict = [];
//   var regex = /^([a-zA-Z0-9]{1,})=([a-zA-Z0-9]{1,})$/;
//   if (TargetSearch.includes('&'))
//     TargetSearch.split('&').forEach((item, index) => {
//       if (regex.test(item))
//         dict.push({ key: item.split('=')[0], value: item.split('=')[1] })
//       else
//         return false;
//     })
//   else {
//     if (regex.test(TargetSearch))
//       dict.push({ key: TargetSearch.split('=')[0], value: TargetSearch.split('=')[1] })
//     else
//       return false;

//   }

//   return dict;
// }

const LoginCtrl = WithFormEvent(Login, {

  onSubmit: function (values, callback) {

    //var url = 'HttpHandler/LoginHandler.ashx';
    var url = 'Login';
    //var data = { action: 'login', ...values };

    // values.UserID = values.UserID ? values.UserID : "Victor";
    var data = { UserCode: values.UserID, Password: values.Password || "" };

    return ajaxPost(url, data).then(response => {

      if (response && response.Session) {

        Object.assign(loginInfo, response);
        loginInfo.UserID = values.UserID.toUpperCase();

        //get location code
        url = 'FB.GetUserConfig';
        data = { Code: loginInfo.UserID, language: loginInfo.language };
        return ajaxPost(url, data).then(response => {

          // console.log(response);
          // console.log(loginInfo);
          if (response) {
            Object.assign(loginInfo, response);
          }

          loginInfo.UserPreference = { Language: loginInfo.language, RefreshFrequency: 30 };

          loginInfo.save();
          loginInfo.startUpdateSession();

          console.log(loginInfo, "window", window, window.TargetURL, window.location.href);


          // var tmpData = {PONo: PONo};
          // Object.assign(tmpData, { needRefresh: true });
          // history.push({
          //   pathname: "/CustomerPO",
          //   state: tmpData
          // })
          if (loginInfo.UserType == "" && loginInfo.UserTypeList.length > 1)
            history.push('/menu');
          // else if(loginInfo.Role == "Management"){
          //   history.push('/HomeManagement');
          // }
          else {
            if (window.TargetURL) {
              // if(window.TargetSearch){
              //   var keypair = ValidSearch(window.TargetSearch);
              //   console.log('keypair',keypair)
              //   var tmpdata = {};
              //   keypair.forEach((item,index)=>{
              //     tmpdata[item.key] = item.value;
              //   })
              //   console.log('tmpData',tmpdata);
              //   // Object.assign(tmpdata, { needRefresh: true })
              //   history.location.search = window.TargetSearch;
              //   window.TargetSearch = "";
              //   history.push({
              //     pathname: window.TargetURL,
              //     state: tmpdata
              //   })
              //   window.TargetURL = "";

              // }

              // else

              var params = window.TargetSearch ? queryString.parse(window.TargetSearch) : {};
              // history.push(window.TargetURL);
              history.push({
                pathname: window.TargetURL,
                state: { ...params, needRefresh: true }
              })

            }

            else if (loginInfo.UserType == "S" || loginInfo.UserTypeList[0] == "S")
              history.push('/Kiosk/Home');
            else if (loginInfo.UserType == "L" || loginInfo.UserTypeList[0] == "L")
              history.push('/Kiosk/ProductLineHome');
            else if (loginInfo.UserType == "M" || loginInfo.UserTypeList[0] == "M")
              history.push('/HomeManagement')
            else
              history.push('/');
          }

        });

      } else {
        alert('Invalid user ID or password.');
      }

      return Promise.resolve({});

    });

  },


})

export default LoginCtrl;


// WEBPACK FOOTER //
// ./src/containers/Master/Login.js